"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var constants_1 = require("./constants");
var Badge_st_css_1 = require("./Badge.st.css");
var defaultProps = {
    type: constants_1.TYPE.solid,
    skin: constants_1.SKIN.general,
    size: constants_1.SIZE.medium,
    uppercase: true
};
var Badge = /** @class */ (function (_super) {
    __extends(Badge, _super);
    function Badge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Badge.prototype.render = function () {
        var _a = this.props, children = _a.children, prefixIcon = _a.prefixIcon, suffixIcon = _a.suffixIcon, onClick = _a.onClick, focusableOnFocus = _a.focusableOnFocus, focusableOnBlur = _a.focusableOnBlur, rest = __rest(_a, ["children", "prefixIcon", "suffixIcon", "onClick", "focusableOnFocus", "focusableOnBlur"]);
        var focusableProps = onClick ? {
            onFocus: focusableOnFocus,
            onBlur: focusableOnBlur,
            'tabIndex': 0
        } : {};
        return (React.createElement("div", __assign({ onClick: onClick }, focusableProps, Badge_st_css_1.default('root', __assign({ clickable: !!onClick }, rest), this.props)),
            prefixIcon && React.cloneElement(prefixIcon, { className: Badge_st_css_1.default.prefix }),
            React.createElement("span", { className: Badge_st_css_1.default.text }, children),
            suffixIcon && React.cloneElement(suffixIcon, { className: Badge_st_css_1.default.suffix })));
    };
    Badge.displayName = 'Badge';
    Badge.defaultProps = defaultProps;
    return Badge;
}(React.PureComponent));
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map